"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonGroup = exports.ButtonGroupContainer = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _styledSystem = require("styled-system");

var _emotionTheming = require("emotion-theming");

var _emotion = require("@rebass/grid/emotion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonGroupContainer = (0, _emotionTheming.withTheme)(function (_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return (0, _core.jsx)(_emotion.Flex, {
    className: className,
    justifyContent: props.align
  }, children);
});
exports.ButtonGroupContainer = ButtonGroupContainer;
var ButtonGroup = (
/*#__PURE__*/
0, _styledBase.default)(ButtonGroupContainer, {
  target: "e1arbqy20"
})("& >:not(:last-child){margin-right:", (0, _styledSystem.themeGet)('spacing.2'), "px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9idXR0b24tZ3JvdXAvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0J1RCIsImZpbGUiOiIuLi8uLi9zcmMvYnV0dG9uLWdyb3VwL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBjb21wb3NlLCBzZXRQcm9wVHlwZXMsIHNldERpc3BsYXlOYW1lLCBkZWZhdWx0UHJvcHMgfSBmcm9tICdyZWNvbXBvc2UnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgdGhlbWVHZXQgfSBmcm9tICdzdHlsZWQtc3lzdGVtJztcbmltcG9ydCB7IHdpdGhUaGVtZSB9IGZyb20gJ2Vtb3Rpb24tdGhlbWluZyc7XG5pbXBvcnQgeyBGbGV4IH0gZnJvbSAnQHJlYmFzcy9ncmlkL2Vtb3Rpb24nO1xuXG5leHBvcnQgY29uc3QgQnV0dG9uR3JvdXBDb250YWluZXIgPSB3aXRoVGhlbWUoKHsgY2hpbGRyZW4sIGNsYXNzTmFtZSwgLi4ucHJvcHMgfSkgPT4gKFxuICA8RmxleFxuICAgIGNsYXNzTmFtZT17Y2xhc3NOYW1lfVxuICAgIGp1c3RpZnlDb250ZW50PXtwcm9wcy5hbGlnbn0+XG4gICAge2NoaWxkcmVufVxuICA8L0ZsZXg+XG4pKTtcblxuZXhwb3J0IGNvbnN0IEJ1dHRvbkdyb3VwID0gc3R5bGVkKEJ1dHRvbkdyb3VwQ29udGFpbmVyKWBcbiAgJiA+IDpub3QoOmxhc3QtY2hpbGQpIHtcbiAgICBtYXJnaW4tcmlnaHQ6ICR7dGhlbWVHZXQoJ3NwYWNpbmcuMicpfXB4O1xuICB9XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBjb21wb3NlKFxuICBzZXREaXNwbGF5TmFtZSgnQnV0dG9uR3JvdXAnKSxcbiAgZGVmYXVsdFByb3BzKHtcbiAgICBhbGlnbjogJ2ZsZXgtc3RhcnQnXG4gIH0pLFxuICBzZXRQcm9wVHlwZXMoe1xuICAgIGFsaWduOiBQcm9wVHlwZXMuc3RyaW5nLFxuICAgIGNsYXNzTmFtZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgfSksXG4pKEJ1dHRvbkdyb3VwKTtcbiJdfQ== */"));
exports.ButtonGroup = ButtonGroup;

var _default = (0, _recompose.compose)((0, _recompose.setDisplayName)('ButtonGroup'), (0, _recompose.defaultProps)({
  align: 'flex-start'
}), (0, _recompose.setPropTypes)({
  align: _propTypes.default.string,
  className: _propTypes.default.string
}))(ButtonGroup);

exports.default = _default;